<button
  *ngIf="show"
  mat-button
  [ngClass]="{
    'custom-button' : true,
    'mdc-button--raised mat-mdc-raised-button': type === 'raised',
    'mdc-button--outlined mat-mdc-outlined-button': type === 'stroked',
    'mdc-button--unelevated mat-mdc-unelevated-button': type === 'flat',
    'mat-mdc-menu-item mdc-list-item': type === 'menu',
  }"
  [color]="color"
  [disabled]="disabledButton || disable"
  [class.spinner]="this.disabledButton && spinner"
  (click)="sendClick()">
  {{ title }}
  <span *ngIf="infoInButton && disable" tiptool="{{ infoInButton }}" placement="left">
    <span class="material-symbols-outlined notranslate">info</span>
  </span>
  <span *ngIf="tooltip" tiptool="{{ tooltip }}" placement="top">
    <span class="material-symbols-outlined notranslate">info</span>
  </span>
</button>
